import React from 'react';
import styled from 'styled-components';
import {Grey700} from '../../Colors';

const Background = styled.div`
    color : ${Grey700};
    text-align : center;
    vertical-align: middle;
    vertical-align : middle;
    padding : 1rem;
    margin : 0.5rem;
`; 
// background: linear-gradient(45deg, transparent, transparent 49%, ${PrimaryColor} 49%, ${PrimaryColor} 51%, transparent 51%, transparent);


const DisableBackground = ({...props}) => <Background {...props}/>;

export default DisableBackground;